/**
 * Route names defined for routes that only ticketSellerAdmin user type can access
 */
export const ticketSellerAdminRouteNames = {
  reportsAdmin: 'ticket-seller-admin-reports',
  reportAdmin: 'ticket-seller-admin-report',
}
